import React, { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import TableAHSF from "../../Components/TableAHSF";
import loadConfig from "../../Services/apiService";

const TableLog = (props) => {
  const dispatch = useDispatch();
  const AppGuid = useParams();
  const [jsonData, setJsonData] = useState({});
  const [popUpBodyOPjectDataStatus, setPopUpBodyOPjectDataStatus] =
    useState(false);
  const [popUpBodyOPjectDataAddStatus, setpopUpBodyOPjectDataAddStatus] =
    useState(false);
  const state = useSelector((state) => {
    return {
      jsonData: state.FetchDataJson.JsonData,
      PersonalInformation: state.PersonalInformation.PersonalInformation,
      ActiveRound: state.ApplicationInformation.ActiveRound,
      ApplicationInformation:
        state.ApplicationInformation.ApplicationInformation,
    };
  });

  const culomEdite = ["email", "fullName"];
  const staticKeyEdite = ["userGUID", "ssoguid", "lastUpdate"];
  const RequestAccessor = [
    {
      KeyName: "actionDescription",
      ShowStatus: true,
      NmaeColumn: "الاجراء",
      TotalNumber: false,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: true,
      GroupOfColumns: false,
    },
    
    // {
    //   KeyName: "firstName",
    //   ShowStatus: true,
    //   NmaeColumn: "الاسم الاول",
    //   TotalNumber: false,
    //   DropdownFiltrationStatus: false,
    //   GroupOfColumns: false,
    // },
    // ,
    // {
    //   KeyName: "lastName",
    //   ShowStatus: true,
    //   NmaeColumn: "الاسم الاخير",
    //   TotalNumber: false,
    //   DropdownFiltrationStatus: false,
    //   GroupOfColumns: false,
    // },
    {
      KeyName: "fullName",
      ShowStatus: true,
      NmaeColumn: "الاسم كامل",
      TotalNumber: false,
      DropdownFiltrationStatus: true,
      DropdownFiltration: {
        keyTextName: "",
        keyValueName: "",
      },
      GroupOfColumns: false,
    },
    {
      KeyName: "actionDate",
      ShowStatus: true,
      NmaeColumn: " تاريخ الاجراء",
      TotalNumber: false,
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "applicationNumber",
      ShowStatus: true,
      NmaeColumn: "رقم الطلب",
      TotalNumber: false,
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
  ];
  const OtherMainBtns = [
    {
      Click: async (e) => {},
      content: "",
      className: "bi bi-view-list",
      id: "editBtn",
      title: "عرض",
      ShowStatus: true,
    },
  ];

  const RequestsColumns = [];
  // send to read props popup
  const PopupOPjectData = {
    isPopupOpenStatus: true,
    isPopupOpenFunction: () => {},
    componentBody: "",
    title: " الاجراءات ",

    maxWidth: "500px",
    maxHeight: "500px",
  };

  const popUpBodyOPjectData = {
    isPopupOpenStatus: popUpBodyOPjectDataStatus,
    isPopupOpenFunction: () => {
      setPopUpBodyOPjectDataStatus(false);
    },
    componentBody: <div></div>,
    title: " الاجراءات",
    maxWidth: "500px",
    maxHeight: "500px",
  };
  const getJson = async () => {
    var json = await loadConfig();
    return json;
  };
  useEffect(() => {
    setJsonData(getJson());
  }, []);
  //console.log(
  //   props.aI_BeneficiaryInformationId,
  //   "props.aI_BeneficiaryInformationId"
  // );

  return (
    <>
      <TableAHSF
        culomEdite={culomEdite}
        uniqueValue={"wF_ApplicationLogId"}
        valueButtonAction={"wF_ApplicationLogId"}
        URL={`api/WFApplication/GetApplicationLog`}
        UrlBody={{
          aI_ApplicationInformationId: localStorage.getItem(
            "aI_ApplicationInformationId_Manager"
          ),
        }}
        staticKeyEdite={staticKeyEdite}
        accessor={RequestAccessor}
        titelTable={" الاجراءات "}
        selectRowNumber={true}
        checkBoksColumName="اختيار"
        sort={true}
        pagination={true}
        AppStatus={false}
        sortTable={true}
        keyNameSort={"actionDate"}
        dateKey="actionDate"
        dateformat="DD/MM/YYYY h:mm a"
        arrayNameSort={["applicationNumber"]}
        search={true}
        modelCondition={state.PersonalInformation}
        KeyCondition={"emailAddress"}
        btnNotToShow="editBtn"
        openPopupState={false}
        DropdownArrayFiltration={[]}
        DropdownFiltration={false}
        exportData={true}
        checkBoks={false}
        nameColumAction=""
        total={false}
        arrayButton={OtherMainBtns}
        ArrayNameDataColum={RequestsColumns}
        columnKeyNameArray={[
          { keyName: "applicationNumber", nameColimn: " رقم الطلب" },
        ]}
        PopupOPjectData={PopupOPjectData}
        popUpTitle={"معلومات الطلب"}
        // popUpBody={
        //   <PopupAHSF
        //     idssss="SecondarySectors"
        //     isPopupOpenStatus={popUpBodyOPjectData.isPopupOpenStatus}
        //     isPopupOpenFunction={popUpBodyOPjectData.isPopupOpenFunction}
        //     title={popUpBodyOPjectData.title}
        //     componentBody={popUpBodyOPjectData.componentBody}
        //     maxWidth={popUpBodyOPjectData.maxWidth}
        //     maxHeight={popUpBodyOPjectData.maxHeight}
        //   />
        // }
        // popUpBody2={[<ShowApplication addFun={true} />]}
        // popUpId2={"ShowApplicationpopUp"}
        // popUpBody2={[
        //   <ShowApplication columnId={columnId} list={list} addFun={false} />,
        // ]}
        // handleCloseModal={handleCloseModal}
        // showModal={showPopUp}
      />
    </>
  );
};
export default TableLog;
